import { buildRhythmTargetId } from "../musicRhythm/rhythmTargetId";
import {
  getActiveDriverTabId,
  isBrowserMultiTabRuntime,
} from "./activeDriverTab";

const TAB_EQUIPMENT_PREFIX = "driver_tab_equipment:";
export const DRIVER_TAB_EQUIPMENT_BOUND_EVENT =
  "eweadn:driverTabEquipmentBound";

export function bindDriverTabEquipment(
  equipment: Record<string, unknown>
): void {
  if (typeof sessionStorage === "undefined") return;
  const pageId = getActiveDriverTabId();
  sessionStorage.setItem(
    `${TAB_EQUIPMENT_PREFIX}${pageId}`,
    JSON.stringify(equipment)
  );
  if (typeof window !== "undefined") {
    window.dispatchEvent(
      new CustomEvent(DRIVER_TAB_EQUIPMENT_BOUND_EVENT, {
        detail: { pageId, equipment },
      })
    );
  }
}

export function getDriverTabBoundEquipment(): Record<string, unknown> | null {
  if (typeof sessionStorage === "undefined") return null;
  const raw = sessionStorage.getItem(
    `${TAB_EQUIPMENT_PREFIX}${getActiveDriverTabId()}`
  );
  if (!raw) return null;
  try {
    const parsed = JSON.parse(raw) as Record<string, unknown>;
    return parsed && typeof parsed === "object" ? parsed : null;
  } catch {
    return null;
  }
}

/** 页签内读设备：优先 session 绑定，避免多页签共用 localStorage 串台 */
export function getTabScopedEquipmentData(): Record<string, unknown> {
  const bound = getDriverTabBoundEquipment();
  if (bound) return bound;
  if (typeof sessionStorage !== "undefined") {
    try {
      const sessionRaw = sessionStorage.getItem("eweadn:session:equipmentData");
      if (sessionRaw) {
        const parsed = JSON.parse(sessionRaw) as Record<string, unknown>;
        if (parsed && typeof parsed === "object") return parsed;
      }
    } catch {
      /* ignore */
    }
  }
  if (typeof localStorage === "undefined") return {};
  try {
    const raw = localStorage.getItem("equipmentData");
    if (!raw) return {};
    const parsed = JSON.parse(raw) as Record<string, unknown>;
    return parsed && typeof parsed === "object" ? parsed : {};
  } catch {
    return {};
  }
}

/** 布局缓存前缀：页签 + 设备唯一标识 */
export function getDriverTabLayoutScopePrefix(): string {
  if (!isBrowserMultiTabRuntime()) return "";
  const pageId = getActiveDriverTabId();
  const bound = getDriverTabBoundEquipment();
  if (!bound) return `tab:${pageId}:`;
  return `tab:${pageId}:${buildRhythmTargetId(bound)}:`;
}

export { isBrowserMultiTabRuntime };
